import { render, staticRenderFns } from "./newFooter.vue?vue&type=template&id=1a835a42&scoped=true&"
import script from "./newFooter.vue?vue&type=script&lang=js&"
export * from "./newFooter.vue?vue&type=script&lang=js&"
import style0 from "./newFooter.vue?vue&type=style&index=0&id=1a835a42&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a835a42",
  null
  
)

export default component.exports